module.exports = __webpack_public_path__ + "static/1446844c-462a-4dba-815d-3a20eeecab55-900.e249d7b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-katharines-chapel-window/1446844c-462a-4dba-815d-3a20eeecab55-900.jpg
// module id = 1090
// module chunks = 168707334958949